import { SxProps } from '@mui/material';

export const ModalRegisterFrameSx: SxProps = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',

	bgcolor: 'background.paper',
	boxShadow: 24,
	padding: '0px',
	paddingTop: '5px',
};

export const ModalRegisterHeaderIconBackSx: SxProps = {
	fontSize: 'var(--font-size-lg)',
};

export const ModalRegisterHeaderIconCloseSx: SxProps = {
	fontSize: 'var(--font-size-xl)',
};

export const ModalRegisterContentSx: SxProps = {
	padding: '0px 40px 20px 40px',
	width: '660px',
};

export const ModalRegisterTitleSx: SxProps = {
	fontSize: 'var(--font-size-xl)',
	fontWeight: 800,
};

export const ModalRegisterDescriptionSx: SxProps = {
	fontSize: 'var(--font-size-default)',
	textAlign: 'left',
	marginBottom: '20px',
};
